import { useState, useEffect, useRef } from "react";
import { RiInformationLine } from "react-icons/ri";

const QuantityInfoTooltip = () => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("touchstart", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div
            ref={containerRef}
            className="relative inline-flex items-center"
            onMouseEnter={() => {
                if (window.matchMedia("(pointer: fine)").matches) {
                    setIsOpen(true);
                }
            }}
            onMouseLeave={() => {
                if (window.matchMedia("(pointer: fine)").matches) {
                    setIsOpen(false);
                }
            }}
        >
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="text-[#8B2433] hover:text-[#A72B3C] transition-colors p-1 flex items-center justify-center rounded-full hover:bg-[#8b24330c] cursor-pointer"
                title="Informazioni sulla quantità"
                aria-label="Informazioni sulla quantità"
                aria-expanded={isOpen}
            >
                <RiInformationLine size="22px" />
            </button>

            {isOpen && (
                <>
                    <style>{`
                        @keyframes tooltipFadeIn {
                            from {
                                opacity: 0;
                                transform: translateY(-8px) scale(0.95);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0) scale(1);
                            }
                        }
                    `}</style>
                    <div
                        style={{ animation: "tooltipFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards" }}
                        className="absolute top-full mt-2.5 left-0 sm:left-auto w-72 sm:w-80 md:w-96 bg-white/95 backdrop-blur-md border border-[#F2C3CA] rounded-2xl shadow-2xl p-5 text-[#303030] text-xs z-50 poppins-regular"
                    >
                        {/* Header */}
                        <div className="flex items-center gap-2 border-b border-[#F2C3CA] pb-2.5 mb-3.5">
                            <span className="w-2 h-2 rounded-full bg-[#8B2433] animate-pulse"></span>
                            <h4 className="font-semibold text-xs text-[#8B2433] poppins-medium">
                                Guida Inserimento Quantità
                            </h4>
                        </div>

                        {/* Content Guidelines */}
                        <div className="flex flex-col gap-3.5">
                            {/* Point 1: Quantità obbligatoria */}
                            <div className="flex flex-col gap-1 border-b border-gray-100 pb-2.5">
                                <span className="self-start px-2 py-0.5 text-[9px] font-medium tracking-wide uppercase rounded border bg-amber-50 text-amber-800 border-amber-200">
                                    Quantità Obbligatoria
                                </span>
                                <p className="text-[11px] leading-relaxed text-gray-600 poppins-regular">
                                    La quantità per ciascun vino è obbligatoria e deve essere pari ad almeno <strong className="text-[#303030]">1</strong>.
                                </p>
                            </div>

                            {/* Point 2: Massimo 3 cifre */}
                            <div className="flex flex-col gap-1">
                                <span className="self-start px-2 py-0.5 text-[9px] font-medium tracking-wide uppercase rounded border bg-emerald-50 text-emerald-800 border-emerald-200">
                                    Massimo 3 Cifre
                                </span>
                                <p className="text-[11px] leading-relaxed text-gray-600 poppins-regular">
                                    È possibile inserire al massimo <strong className="text-[#303030]">3 cifre</strong> (quantità massima consentita: <strong className="text-[#303030]">999</strong>). Cifre extra o caratteri non numerici non vengono accettati.
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default QuantityInfoTooltip;

